export default __webpack_public_path__ + "static/image-2-15adaced2a60643272bbc16a37c1ee37.png";